
window.dzswtl_block_changes = false; // -- block instant changes if there is a button that trigger changes
window.dzswtl_collect_args_in_timeout = false; // -- place a timeout so that filters can be collected
window.dzswtl_collect_args = {}; // -- args collected
window.dzswtl_total_attribute_data = {}; // -- args collected
window.dzswtl_current_ids_on_page = []; // -- args collected

var dzs_helpers = require('./js_common/_dzs_helpers')

const assets = require('./js_dzswtl/assets');

(function($) {
  $.fn.dzswootable = function (o) {
    var defaults = {
      pagination_max_number_of_visible_items_per_side: '3' //in seconds
      , settings_preloadall: 'on'
      , settings_dummy_items_nr: 10
      , grid: 'dzs-layout--5-cols'
      , input: ''

    }


    o = $.extend(defaults, o);
    this.each(function () {
      var cthis = $(this);


      var ww = 0 // -- window w
      ;
      var mousex
        , mousey
      ;
      var loaded = false
        , mouseover = false
        , busy = false

      ;



      var hard_coded_keys = {};




      var _pagination = null;


      var feed_from_arr = {};

      var pages_curr = 1
        ,pages_max
      ;


      var arg_posts_per_page_changed = false
        ,arg_layout_changed = false
        ,sw_enable_multisharer = false
      ;


      var woo_search_inter = 0;

      var _w = $(window);

      var inter_collect_args = 0;

      var recalculate_attribute_data = false;


      var pagination_max_number_of_visible_items_per_side = 3;

      var pagination_method = 'pages';

      init();
      function init() {

        pagination_max_number_of_visible_items_per_side = parseInt(o.pagination_max_number_of_visible_items_per_side, 10);

        // console.log('window.dzswtl_curr_args - ',window.dzswtl_curr_args)

        _pagination = $('.dzs-woo-table.shop-index-1 .dzs-pagination').eq(0);


        feed_from_arr = {}; // -- feed_from_arr is based on data-dzs-woo-feed-lab


        if(cthis.attr('data-hard-coded-keys')){
          hard_coded_keys = JSON.parse(cthis.attr('data-hard-coded-keys'));
        }

        var selector_ajax = '.dzs-woo-ajax';


        // $(document).on('click.dzswtl',selector_ajax, handle_mouse);
        $(document).on('click.dzswtl',selector_ajax+',.dzs-woo-table-sort-input,.delete-filter, .clear-all-filters, .dzs-wtl-submit-changes-btn,.increment-val,.decrement-val, .pagination-link', handle_mouse);

        // console.log('document event listeners - ', document.getEventListeners(document));

        // dzs-woo-table-filter-input
        $(document).on('change.dzswtl','.dzs-woo-table-filter-input:not(.dzs-select-wrapper), select.attribute-selector, *[name="woo_sort"]', handle_change);
        $(document).on('click.dzswtl','.dzs-woo-table-filter-for-click', handle_change);
        $(document).on('keyup.dzswtl','*[name="woo_search"]', handle_change);

        $(window).on('resize',handle_resize);

        handle_resize();



        $('.dzs-woo-feed-filter-from').each(function(){
          var _t = $(this);

          // console.info(_t);

          feed_from_arr[_t.attr('data-dzs-woo-feed-lab')] = _t.attr('data-dzs-woo-feed-type');
        })

        // console.info('feed_from_arr initial - ',feed_from_arr);

        pagination_method = cthis.attr('data-pagination-method');


        if(cthis.attr('data-recalculate_attribute_data')=='on'){
          recalculate_attribute_data = true;
        }

        // console.warn('recalculate_attribute_data -> ',recalculate_attribute_data);

        if(recalculate_attribute_data){
          try{
            window.dzswtl_total_attribute_data = JSON.parse($('.feed-dzswtl-total-attribute-data').eq(0).attr('data-attdata'));


          }catch(err){

          }

          // console.info('window.dzswtl_total_attribute_data -' ,window.dzswtl_total_attribute_data);



          // -- recalculate attribute data to adjust filters
          func_recalculate_attribute_data();
        }

        if(pagination_method=='scroll'){
          $(window).on('scroll', handle_scroll);


          window.addEventListener('mousewheel', function(e){

            var cannot_have_scroll = false;
            if (document.body.clientHeight < window.innerHeight) {
              cannot_have_scroll = true;
            }
            if(cannot_have_scroll){
              handle_scroll(e);
            }
          });
        }

        // console.warn('feed_from_arr -> ',feed_from_arr);


        cthis.css('opacity','');
        setTimeout(function(){
          cthis.addClass('inited');
        },100);





        if(String($('.dzs-woo-table--inner').eq(0).html()).indexOf('dzswtl-multisharer-but')>-1){


          sw_enable_multisharer = true;
        }


        // console.info("String($('.dzs-woo-table--inner').eq(0).html()) -> ", String($('.dzs-woo-table--inner').eq(0).html()))
        // console.info("sw_enable_multisharer -> ", sw_enable_multisharer)



        if(sw_enable_multisharer){
          setTimeout(function(){
            // console.info("LOAD MULTISHARER");


            if (window.dzswtl_settings && window.dzswtl_settings.site_url) {


              window.loading_multi_sharer = true;
              var head  = document.getElementsByTagName('head')[0];
              var link  = document.createElement('link');
              link.id   = 'dzswtl-load-multi-sharer';
              link.rel  = 'stylesheet';
              link.type = 'text/css';
              link.href = dzs_helpers.add_query_arg(window.dzswtl_settings.site_url,'dzswtl-load-lightbox-css','on');
              link.media = 'all';
              head.appendChild(link);



              setTimeout(function(){

                $('body').append('<div class="dzswtl-main-con skin-default gallery-skin-default transition-slideup "> <div class="overlay-background"></div> <div class="box-mains-con"> <div class="box-main" style=""> <div class="box-main-media-con transition-target"> <div class="close-btn-con"> <svg enable-background="new 0 0 40 40" id="" version="1.1" viewBox="0 0 40 40" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g><path d="M28.1,26.8c0.4,0.4,0.4,1,0,1.4c-0.2,0.2-0.5,0.3-0.7,0.3s-0.5-0.1-0.7-0.3l-6.8-6.8l-6.8,6.8c-0.2,0.2-0.5,0.3-0.7,0.3 s-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4l6.8-6.8l-6.8-6.8c-0.4-0.4-0.4-1,0-1.4c0.4-0.4,1-0.4,1.4,0l6.8,6.8l6.8-6.8 c0.4-0.4,1-0.4,1.4,0c0.4,0.4,0.4,1,0,1.4L21.3,20L28.1,26.8z"></path></g><g><path d="M19.9,40c-11,0-20-9-20-20s9-20,20-20c4.5,0,8.7,1.5,12.3,4.2c0.4,0.3,0.5,1,0.2,1.4c-0.3,0.4-1,0.5-1.4,0.2 c-3.2-2.5-7-3.8-11-3.8c-9.9,0-18,8.1-18,18s8.1,18,18,18s18-8.1,18-18c0-3.2-0.9-6.4-2.5-9.2c-0.3-0.5-0.1-1.1,0.3-1.4 c0.5-0.3,1.1-0.1,1.4,0.3c1.8,3.1,2.8,6.6,2.8,10.2C39.9,31,30.9,40,19.9,40z"></path></g></svg></div> <div class="box-main-media type-inlinecontent" style="width: 530px; height: 280px;"><div class=" real-media" style=""><div class="hidden-content share-content" > <div class="social-networks-con"></div> <div class="share-link-con"></div> <div class="embed-link-con"></div> </div> </div> </div> <div class="box-main-under"></div> </div> </div> </div><!-- end .box-mains-con--> </div>');


                console.warn('dzswtl-multisharer-but -> ',$('.dzswtl-multisharer-but'));
                $(document).on('click.dzswtl','.dzswtl-multisharer-but', click_open_embed_ultibox);
                $(document).on('click.dzswtl','.dzswtl-main-con .close-btn-con,.dzswtl-main-con .overlay-background', function(){

                  var _c = $('.dzswtl-main-con').eq(0);

                  _c.removeClass('loading-item loaded-item');
                })
              },1000);




            }
          },2000)
        }


        // console.log('wootable - cthis.find(\'.dzsap-multisharer-but\') - ',cthis.find('.dzsap-multisharer-but'));
        if(cthis.find('.dzsap-multisharer-but').length){
          if(window.dzsap_init_multisharer){

            window.dzsap_init_multisharer();
          }
        }


        reinit();
        reinit_stars();
        reinit_pagination()
      }

      function handle_resize(e){
        ww = window.innerWidth;

        // console.info('ww - ',ww);

      }

      function func_recalculate_attribute_data(){

        $('.multiple-option').each(function(){

          var _t = $(this);
          var term_id = _t.attr('data-term_id');

          // console.info(_t,term_id);
          // console.info('window.dzswtl_total_attribute_data - ',window.dzswtl_total_attribute_data);



          if(window.dzswtl_total_attribute_data[term_id]){
            // -- found
            _t.removeClass('no-terms-on-this-page');
            // console.warn('window.dzswtl_total_attribute_data[term_id] ->', window.dzswtl_total_attribute_data[term_id]);
            _t.find('.the-actual-count').html(window.dzswtl_total_attribute_data[term_id]);
          }else{

            _t.addClass('no-terms-on-this-page');

          }


        })
      }

      function reinit(){

        // console.error('dzswtl reinit');


        cthis.find('.wootable-row').each(function(){
          var _trow = $(this);

          // console.info('_trow - ',_trow);

          if(_trow.find('.col-feed-from-product-image').length){
            if(_trow.find('.col-feed-from-product-image').children().length){
              _trow.addClass('has-featured-image');
            }
          }


          // console.info('_trow -> ' , _trow);



          if(_trow.hasClass('has-featured-image')==false){
            if(_trow.find('.zoomsounds-mode-just-play-button').length && _trow.find('.zoomsounds-mode-just-waveform').length){
              _trow.addClass('has-just-play-and-has-just-waveform')
            }
          }
        })


        dzswtl_filter_from_reinit();

        get_current_ids_on_page();
      }

      function get_current_ids_on_page(){
        // -- called on reinit
        window.dzswtl_current_ids_on_page = [];


        $('.wootable-row').each(function(){
          var _t = $(this);

          if(_t.attr('data-post-id')){

            window.dzswtl_current_ids_on_page.push(_t.attr('data-post-id'));
          }
        })

        // console.info('window.dzswtl_current_ids_on_page - ',window.dzswtl_current_ids_on_page);

        if(window.dzswtl_settings && window.dzswtl_settings.filter_check_availability=='on'){


          var filters_arr = [];
          $('.dzs-woo-feed-filter-from').each(function(){
            var _t = $(this);

            var lab = _t.attr('data-dzs-woo-feed-lab');

            var reallab = '';
            if(lab.indexOf('customtax_')===0){
              reallab = lab.replace('customtax_','');
            }else{

              if(lab.indexOf('pa_')===0){
                reallab = lab;
              }
            }


            if(reallab){
              filters_arr.push(reallab);
            }

            // console.info('lab - ',lab);
          })

          // $('.bigoption.select-option').removeClass('was-not-found');
          // console.warn('filters_arr - ',filters_arr);
          $.ajax({
            async: "false"
            , method: "POST"
            // ,contentType: "application/x-www-form-urlencoded; charset=UTF-8"
            // ,type: "POST"
            , url: window.dzswtl_settings.admin_url + '?dzswtl_action=load_filter_availability'
            , data: {
              hmm: 'ceva'
              , postdata: JSON.stringify(filters_arr)
            }
            , dataType: 'html'
            , success: function (response) {
              // console.info(response);


              var dataarr = [];
              try{
                dataarr =null;


                $('.bigoption.select-option').removeClass('was-not-found');
                try{
                  dataarr =  JSON.parse(response);;

                  
                  // console.groupCollapsed('log load_filter_availability ( dataarr ) ');
                  // console.log('dataarg - ' ); console.table(dataarr);
                  // console.groupEnd();

                  // console.log('dataarr - ',dataarr);
                  for(var tax_lab in dataarr){
                    for( var term_lab in dataarr[tax_lab]){
                      var ids_in_big_terms = dataarr[tax_lab][term_lab];

                      var sw_found = false;

                      var count_on_page = 0;

                      // -- for each taxonomy / attribute
                      for(var lab in ids_in_big_terms){
                        var id_in_big_term = ids_in_big_terms[lab];

                        // -- if we calculate disregarding pagination
                        if(window.dzswtl_current_ids_on_page_from_all_shop_pages && window.dzswtl_current_ids_on_page_from_all_shop_pages.length){
                          window.dzswtl_current_ids_on_page = window.dzswtl_current_ids_on_page_from_all_shop_pages;
                        }
                        for(var i in window.dzswtl_current_ids_on_page){
                          var check_val = window.dzswtl_current_ids_on_page[i];

                          if(check_val==id_in_big_term){
                            count_on_page++;
                            sw_found=true;
                          }
                        }

                        // console.info('term_lab - ',term_lab, 'count_on_page - ', count_on_page);
                      }


                      if(window.dzswtl_settings && window.dzswtl_settings.filter_check_availability_recalculate_count=='on'){

                        var _c_filter_label = $('.dzs-woo-filter[data-lab-sanitized*="'+tax_lab+'"] label[data-term_slug="'+term_lab+'"]');

                        _c_filter_label.each(function(){
                          var _t3 = $(this);
                          _t3.find('.the-actual-count').html(_t3.attr('data-count'));
                        })



                        if(count_on_page){


                          _c_filter_label.each(function(){
                            var _t3 = $(this);
                            _t3.find('.the-actual-count').html(count_on_page);
                          })

                        }


                      }



                      // console.log('_c_filter_label - ', _c_filter_label, 'found - ',sw_found, count_on_page);
                      if(sw_found){
                        _c_filter_label.removeClass('was-not-found');
                        _c_filter_label.parent().removeClass('was-not-found');

                      }else{
                        // console.log('%c here ','color: #ff0000;')
                        _c_filter_label.addClass('was-not-found');
                        _c_filter_label.parent().addClass('was-not-found');

                      }
                      // console.info('ids - ',ids, 'lab - ',tax_lab, term_lab);
                      // console.warn('window.dzswtl_current_ids_on_page - ',window.dzswtl_current_ids_on_page);
                    }
                  }
                }catch(err){
                  console.info('err - ',err);
                }



              }catch(err){
                console.warn(err);
              }
            }
          })

        }
      }



      function click_open_embed_ultibox() {


        // console.info('ceva');

        var _c = $('.dzswtl-main-con').eq(0);

        // console.info('_c -> ',_c, cgallery.find('.feed-dzswtl--for-social-networks').eq(0).html(), _c.find('.social-networks-con'));





        var aux = '';

        if(window.dzswtl_social_feed_for_social_networks){
          aux = window.dzswtl_social_feed_for_social_networks;
        }


        aux = aux.replace(/{{replacewithdataurl}}/g,$(this).attr('data-url'));

        _c.find('.social-networks-con').html(aux);



        aux = '';
        if(window.dzswtl_social_feed_for_share_link){
          aux = window.dzswtl_social_feed_for_share_link;
        }


        if(aux){

          aux = aux.replace(/{{replacewithdataurl}}/g,$(this).attr('data-url'));
          aux=aux.replace('{{replacewithcurrurl}}',window.location.href);
          _c.find('.share-link-con').html(aux);
        }

        aux = '';
        if(window.dzswtl_social_feed_for_embed_link){
          aux = window.dzswtl_social_feed_for_embed_link;
        }


        if(o.embed_code){

          if(aux) {
            aux = aux.replace('{{replacewithembedcode}}', htmlEntities(o.embed_code));
            _c.find('.embed-link-con').html(aux);
          }

        }

        $(document).on('click.dzswtl','.field-for-view', function(){

          // console.info("HMM ", this);
          // selectText(this);

          $(this).select();
        });
        setTimeout(function(){

          _c.addClass('loading-item');
        },100);

        setTimeout(function(){
          _c.addClass('loaded-item');
        },200);

        return false;
      }


      function reinit_pagination(){

        // console.log('reinit_pagination - ',_pagination);

        var currIndex = _pagination.children().index(_pagination.children('.current').eq(0));

        // console.log(currIndex);
        _pagination.children().removeClass('pagination-is-hidden');

        var i = 0, limit_min, limit_max;
        _pagination.children().each(function(){


          var pagination_actual_nr_of_visible_items_quadruple = Math.ceil(pagination_max_number_of_visible_items_per_side/2);

          if(pagination_max_number_of_visible_items_per_side + 2<currIndex){

            // console.log('limit_min - ', limit_min, 'limit_max -', limit_max);

            limit_min = pagination_actual_nr_of_visible_items_quadruple;
            limit_max = currIndex - pagination_actual_nr_of_visible_items_quadruple;
            for (i = limit_min; i<limit_max; i++){
              _pagination.children().eq(i).addClass('pagination-is-hidden');
            }


          }

          limit_max = _pagination.children().length;
          if(pagination_max_number_of_visible_items_per_side + 2 < limit_max - currIndex){

            limit_min = currIndex + 1 + pagination_actual_nr_of_visible_items_quadruple;
            limit_max = _pagination.children().length - pagination_actual_nr_of_visible_items_quadruple - 1;
            for (i = limit_min; i<limit_max; i++){
              _pagination.children().eq(i).addClass('pagination-is-hidden');
            }
          }

          // if(pagination_max_number_of_visible_items_per_side< currIndex){
          //
          //   for (var i = 0; i<currIndex; i++){
          //
          //
          //   }
          // }
        })
      }

      function reinit_stars(){
        var _c = $('.star-rating-con');
        if(_c.length){



          _c.each(function(){
            var _t = $(this);


            // -- we reinit

            var aux = _t.html();

            // console.info('aux - ',aux);


            if(aux.indexOf('{{starssvg}}')>-1){
              aux = aux.replace(/{{starssvg}}/g, assets.svg_star+assets.svg_star+assets.svg_star+assets.svg_star+assets.svg_star);
              _t.html(aux);
            }
          })


        }
      }

      function handle_scroll(e){

        var windowh = _w.scrollTop() + _w.height();

        if(pages_curr>=pages_max){
          return ;
        }

        if(windowh>=cthis.offset().top + cthis.outerHeight() -30){

          if(busy){

          }else{
            console.info("LETS LOAD NEXT PAGE", pages_curr, pages_max);


            load_new_content({
              'paged':pages_curr+1
              ,'call_from':'scroll'
            })


          }




        }
      }

      function woo_search(arg){


        var args = {};



        // args['search'] = arg;

        if($('*[name=woo_search]').eq(0).val()){

        }
        args['search'] = $('*[name=woo_search]').eq(0).val();
        args['call_from'] = 'searcher';



        console.info("SENDING ARGS from search -> ",args, $('*[name=woo_search]').eq(0).val());

        load_new_content(args)
      }

      function handle_change(e) {
        // -- @handle a filter change or a sort change

        var _t = $(this);

        // console.info('handle_change() _t -> ', _t, e);


        setTimeout(function(){

          dzswtl_filter_from_reinit();
        },500);

        if(window.dzswtl_block_changes){
          return false;
        }

        if (e.type == 'keyup') {

          if(_t.attr('name')=='woo_search'){

            clearTimeout(woo_search_inter);


            console.info('search..', _t.val());
            woo_search_inter = setTimeout(woo_search, 700, _t.val());

          }
        }
        if (e.type == 'click') {
          console.info("CLICK here ", _t);


          if(_t.hasClass('dzs-woo-table-filter-for-click')){
            var _con = _t.parent();

            var _filter_from = _con.find('.dzs-woo-feed-filter-from').eq(0);

            // console.info('_filter_from', _filter_from);



            var lab = _filter_from.attr('data-dzs-woo-feed-lab');

            var args = {};

            if(_t.hasClass('active')){

              _t.parent().children().removeClass('active');
              args[lab]='';
              load_new_content(args)
            }else{



              _t.parent().children().removeClass('active');
              // console.log('_t - ',_t);
              _t.addClass('active');


              args[lab]=_t.attr('data-term-slug');
              load_new_content(args)
            }



          }
        }
        if (e.type == 'change') {
          // console.info("CHANGE -3",_t);

          if(_t.attr('name')=='woo_sort'){
            // -- only for sorting

            // console.info(_t, _t.val());

            var args = {};

            var val = String(_t.val());

            if(_t.val()=='newest-to-oldest'){

              args['order'] = 'desc';
              args['orderby'] = 'date';
              args['paged'] = '1';


              // load_new_content(args)
            }

            if(_t.val()=='oldest-to-newest'){


              // console.error('hier');

              args['order'] = 'asc';
              args['orderby'] = 'date';
              args['paged'] = '1';


            }
            if(_t.val()=='alphabetical{asc}'){


              // console.error('hier');
              args['order'] = 'asc';
              args['orderby'] = 'title';
              args['paged'] = '1';
            }
            if(_t.val()=='alphabetical{desc}'){


              // console.error('hier');
              args['order'] = 'desc';
              args['orderby'] = 'title';
              args['paged'] = '1';
            }
            if(_t.val()=='ratings_score{asc}'){


              // console.error('hier');
              args['order'] = 'asc';
              args['orderby'] = 'ratings_score';
              args['paged'] = '1';
            }
            if(_t.val()=='ratings_score{desc}'){


              // console.error('hier');
              args['order'] = 'desc';
              args['orderby'] = 'ratings_score';
              args['paged'] = '1';
            }

            if(_t.val()=='cheap-to-expensive'){


              // console.error('hier');

              args['order'] = 'asc';
              args['orderby'] = 'price';
              args['paged'] = '1';


            }
            if(_t.val()=='expensive-to-cheap'){


              // console.error('hier');

              args['order'] = 'desc';
              args['orderby'] = 'price';
              args['paged'] = '1';


            }
            if(val.indexOf('pa_')===0){


              var order = /{.*?}/g.exec(val)[0];
              var orderby = val.replace(/{.*?}/g,'');


              console.info('order - ',order);

              if(order=='{asc}'){

                args['order'] = 'asc';
              }else{

                args['order'] = 'desc';
              }
              args['orderby'] = orderby;
              args['paged'] = '1';


            }
            load_new_content(args)

            // -- only for sorting END
          }





          // -- filter input
          if(_t.hasClass('attribute-selector')){


            // console.info('_t - ',_t);

            var val = _t.val();
            // console.info('val -5 ',val);


            var _c = _t.find(':selected');

            // console.info('_c -4 ',_c);

            if(_c.attr('data-price')){


              // console.info('_t.parent().parent().parent().find(\'.price-highlight\').length - ',_t.parent().parent().parent().find('.price-highlight'), _t.parent().parent().parent());

              if(_t.parent().parent().parent().parent().find('.price-highlight').length){
                _t.parent().parent().parent().parent().find('.price-highlight > .the-price-number').eq(0).html(_c.attr('data-price'));
              }
            }
          }


          // -- filter input
          if(_t.hasClass('dzs-woo-table-filter-input')){
            // console.groupCollapsed("change call");
            // console.info("woo table inner", 'dzs-woo-table-filter-input',_t.attr('name'), _t.val());

            if(_t.attr('type')=='checkbox'){
              // console.log(_t.prop('checked'));
            }



            var lab = _t.attr('name');

            var lab_sanitized_no_arr = lab;


            try{
              lab_sanitized_no_arr = lab.replace('[]','');
            }catch(err){

            }

            // console.warn('lab - ',lab, lab_sanitized_no_arr, _t, feed_from_arr);


            // console.log('%c feed_from_arr - ', 'color: #dadada;', feed_from_arr);

            var seek_lab = '';
            var seek_type = '';
            for(var key in feed_from_arr){

              // console.log('lab_sanitized_no_arr - ',lab_sanitized_no_arr, 'key - ',key);
              if(lab_sanitized_no_arr==key){

                seek_lab = key;
                seek_type = feed_from_arr[key];
                break;
              }
            }



            if(seek_type=='none'){
              seek_type = 'select';
            }


            // console.warn('feed_from_arr - ',feed_from_arr);
            // console.warn('seek_lab - ',seek_lab);
            console.warn('seek_type - ',seek_type);


            var vals = '';

            if(seek_type=='multiple'){

              $('*[name="'+lab+'"]').each(function(){
                var _t2 = $(this);


                if(_t2.attr('type')=='checkbox'){
                  if(_t2.prop('checked')){
                    if(vals){
                      vals+=','+_t2.val();
                    }else{

                      vals+=''+_t2.val();
                    }
                  }
                }

              })
            }



            if(seek_type=='select' || seek_type=='slider'){

              // console.error('hier lab in slider/select - ',lab);
              $('*[name="'+lab+'"]').each(function(){
                var _t2 = $(this);


                // console.info("FOUND _T2 - ",_t2);

                // -- select .. single val



                vals=_t2.val();




              })
            }
            if(seek_type=='input'){

              var _t2 = $('*[name="'+lab+'"]');

              vals = _t2.val();
            }

            var args = {};

            args[lab_sanitized_no_arr] = vals;



            if(window.dzswtl_collect_args_in_timeout){
              window.dzswtl_collect_args = $.extend(window.dzswtl_collect_args, args);
              for(var labLoop in args){
                window.dzswtl_collect_args[labLoop]=args[labLoop];
              }
            }

            // console.warn('vals - ',vals);
            // console.warn('args - ',args);
            // console.warn('window.dzswtl_collect_args - ',window.dzswtl_collect_args);
            // console.groupEnd();

            // -- end group
            args.call_from = 'filter-input';





            load_new_content(args);
          }
        }
      }
      function handle_mouse(e) {

        var _t = $(this);

        // console.info(_t);

        // console.info("CEVA");
        if (e.type == 'click') {
          // console.info("CEVA");


          if (_t.hasClass('pagination-link')) {
            // -- pagination click

            _t.parent().children().removeClass('current');
            _t.addClass('current');


            setTimeout(function(){

              // console.info('$(".dzs-woo-table").eq(0) - ',$(".dzs-woo-table").eq(0));
              // console.info('$(".dzs-woo-table").eq(0).offset().top - ',$(".dzs-woo-table").eq(0).offset().top);


              var aux = parseInt($(".dzs-woo-table").eq(0).offset().top,10);



              $('html,body').animate({
                scrollTop: aux - 200
              }, 500);
              // $('body').animate({
              //     scrollTop: aux
              // }, 500);

              // window.scrollTo(0, aux);


            },1000);

          }
          if (_t.hasClass('increment-val')) {
            if(_t.parent().find('input[name="quantity"]').length){
              var _c = _t.parent().find('input[name="quantity"]').eq(0);


              _c.val(Number(_c.val())+1);
            }
          }
          if (_t.hasClass('decrement-val')) {
            if(_t.parent().find('input[name="quantity"]').length){
              var _c = _t.parent().find('input[name="quantity"]').eq(0);


              var tempnr = Number(_c.val())-1;

              if(tempnr<0){
                tempnr = 0;
              }
              _c.val(tempnr);
            }
          }
          if (_t.hasClass('dzs-woo-ajax')) {

            load_new_content(dzs_helpers.get_query_arg_all(_t.attr('href')));


            e.stopPropagation();
            e.preventDefault();
            _t.get(0).dzs_stop_propagation = true;
            return false;
          }

          if (_t.hasClass('delete-filter')) {


            // -- delete filter

            var args = {};



            args[_t.attr('data-lab_full')] = '';

            // -- selects

            var _c = $('select[name="'+_t.attr('data-lab_full')+'"]').eq(0);

            _c.val('');

            _c.trigger('change');

            // -- multiples

            // console.info('_t - ',_t, _t.attr('data-lab_full'));
            $('*[name="'+_t.attr('data-lab_full')+'[]"]').each(function(){
              var _t2 = $(this);

              _t2.prop('checked',false);
              _c.trigger('change');
            });




            // console.info("REMOVE FILTER - ",_c.get(0).api_recheck_value_from_input)

            if(_c.get(0) && _c.get(0).api_recheck_value_from_input){
              _c.get(0).api_recheck_value_from_input();
            }
            // $('select[name='+_t.attr('data-lab_full')+']').val('');


            console.info('check args -> ',args);


            load_new_content(args);


            return false;
          }

          if (_t.hasClass('clear-all-filters')) {


            // -- delete filter
            var args = {};



            // args[_t.attr('data-lab_full')] = '';

            // -- selects

            $('.dzs-woo-filter').each(function(){
              var _t3 = $(this);



              if(_t3.attr('data-lab-sanitized')){

                var lab = _t3.attr('data-lab-sanitized');
                args[lab] = '';

                var lab_sanitized = lab.replace('customtax_','');

                args[lab_sanitized] = '';
              }
            })


            var _c = $('*[name*="customtax_pa_"]');




            // -- multiples

            // console.info('_t - ',_t, _t.attr('data-lab_full'));
            $('*[name*="customtax_pa_"]').each(function(){
              var _t2 = $(this);

              _t2.prop('checked',false);
              // _c.trigger('change');
            });



            var filters = [];
            $('.dzs-woo-table-filter-input').each(function () {
              var _t = $(this);
              // console.log(_t);

              if(_t.attr('name') && filters.indexOf(_t.attr('name'))==-1){
                filters.push(_t.attr('name'))
              }
            });

            filters.forEach(function(el){
              // console.info('el - ',el);

              args[el] = '';
            })
            // console.log('found filters - ',filters);

            // console.info("REMOVE FILTER - ",_c.get(0).api_recheck_value_from_input)


            _c.each(function(){
              var _t2 = $(this);

              if(_t2.get(0) && _t2.get(0).api_recheck_value_from_input){
                _t2.get(0).api_recheck_value_from_input();
              }
            });

            args.call_from = 'clear-all-filters';
            // $('select[name='+_t.attr('data-lab_full')+']').val('');

            // console.log('hard_coded_keys - ',hard_coded_keys);
            if(hard_coded_keys && Object.keys(hard_coded_keys).length){
              // console.warn('here');
              for(var key in hard_coded_keys){
                args[key] = hard_coded_keys[key];
              }
            }


            console.info('check args ( clear-all-filter ) -> ',args);


            load_new_content(args);


            return false;
          }



          if (_t.hasClass('dzs-woo-table-sort-input')) {


            console.info('dzs-woo-table-sort-input clicked', _t);
            var args = {};


            if(_t.parent().hasClass('sorting-asc') || _t.parent().hasClass('sorting-desc')){


              args['order']='';
              args['orderby']='';
              _t.parent().removeClass('sorting-asc sorting-desc');
            }else{

              args['orderby'] = _t.attr('data-sort-lab');

              if(_t.hasClass('sort-asc')){

                args['order'] = 'asc';
                _t.parent().addClass('sorting-'+args['order']);
              }
              if(_t.hasClass('sort-desc')){

                args['order'] = 'desc';
                _t.parent().addClass('sorting-'+args['order']);
              }
            }
            args['call_from']='sort-input';



            load_new_content(args);

          }
          if (_t.hasClass('dzs-wtl-submit-changes-btn')) {

            window.dzswtl_block_changes = false;



            var timeout = 10;
            $('.dzs-woo-table-filter-input').each(function(){
              var _t3 = $(this);


              setTimeout(function(arg){
                arg.trigger('change');
              },timeout,_t3);

              timeout+=10;


            })
          }
          if (_t.hasClass('builder-layer--btn-delete')) {
          }
        }
      }


      function load_new_content(pargs){


        var margs = {
          'call_from':'default',
          'paged':''
        };


        if(pargs){
          margs = $.extend(margs,pargs);
        }

        // console.info('%c load_new_content() - margs -', 'color: #ff4444;',margs);


        // -- leave a delay to accumulate
        if(window.dzswtl_collect_args_in_timeout && margs.call_from!='now_do_it' && margs.call_from!='sort-input'){
          clearTimeout(inter_collect_args);

          setTimeout(function(){
            var args = $.extend({},window.dzswtl_collect_args);


            args.call_from = 'now_do_it';



            if(margs.table_paged!=''){
              args.table_paged = margs.table_paged;
            }
            load_new_content(args)
          },300);

          return;

        }

        if(busy){
          return;
        }


        var _targetShop = null;

        if($('.dzs-woo-table').length){
          _targetShop = $('.dzs-woo-table').eq(0);
        }

        if(_targetShop===null){
          return;
        }

        if(_targetShop.attr('data-max_num_pages')=='1' && margs.call_from=='scroll'){
          return;
        }



        var curr_args = {};


        // console.info('window.dzswtl_curr_args -5 ',window.dzswtl_curr_args, '.... ||| window.dzswtl_curr_args - ',Object.assign({}, window.dzswtl_curr_args));

        window.dzswtl_curr_args = window.dzswtl_curr_args.replace(/{{escape}}/g, '\\');
        try{
          curr_args = JSON.parse(window.dzswtl_curr_args);
        }catch(err){
          console.info('json parse error - ',window.dzswtl_curr_args);
          console.error(err)
        }

        // console.info('load_new_content() curr args before extend -> ',curr_args);

        if(margs.table_paged){
          margs.paged = margs.table_paged;
        }


        curr_args = $.extend(curr_args, margs);
        // console.log('%c curr_args - ', 'color: #eda222;', curr_args);

        for(var lab in curr_args){
          var val = curr_args[lab];

          if(val=='wtn-wtn'){
            delete curr_args[lab];
          }
        }


        // console.log('%c hard_coded_keys BEFORE sending POST args -  - ','background-color: #999;',hard_coded_keys);
        for(var lab in hard_coded_keys){
          curr_args[lab] = hard_coded_keys[lab];
        }



        if(cthis.attr('data-post-id')){
          curr_args.called_from_post_id = cthis.attr('data-post-id');
        }

        // console.info('load_new_content() curr_args - ',curr_args);

        curr_args.return_only_items = "on";
        curr_args.page_url = window.location.href;

        if(curr_args.call_from == 'filter-input' || curr_args.call_from == 'searcher'){
          cthis.attr('data-random-posts','');
        }

        if(cthis.attr('data-random-posts')){
          curr_args.ids = cthis.attr('data-random-posts');
          curr_args.paged = Number(cthis.attr('data-curr_paged'))+1;

          if(pages_curr>=pages_max){
            console.info('no more random content');
            return false;
          }
        }


        // console.info('%c log sending POST args - ','color: #aaa;', curr_args,window.dzswtl_settings.site_url,JSON.stringify(curr_args));


        var curr_args_str = JSON.stringify(curr_args);



        window.dzswtl_curr_args = curr_args_str;

        cthis.addClass('loading');

        busy = true;
        //postdata: JSON.stringify(curr_args)


        // -- load new content


        //,
        $.ajax({
          async: "false"
          ,method: "POST"
          // ,contentType: "application/x-www-form-urlencoded; charset=UTF-8"
          // ,type: "POST"
          , url: window.dzswtl_settings.admin_url + '?dzswtl_action=load_new_content'
          , data: {
            postdata: curr_args_str
          }
          ,dataType: 'html'
          ,success: function(response){
            // console.info(response);


            try{

              var response_arr = JSON.parse(response);
              var newurl = '';

              console.groupCollapsed("load_new_content RESPONSE");
              console.table(response_arr);
              console.info('output - ',response_arr.output);
              console.groupEnd();

              if(window.dzsap_settings){
                if(window.dzsap_init){

                  setTimeout(function(){
                    window.dzsap_call_init_calls();
                  },2);

                }else{
                  console.error("NO ZOOMSOUNDS ?");







                  jQuery.getScript(window.dzsap_settings.dzsap_site_url+"wp-content/plugins/dzs-zoomsounds/audioplayer/audioplayer.js", function(){

                    // alert("Script loaded but not necessarily executed.");


                    dzsap_init('.audioplayer-tobe.auto-init', {
                      init_each: true
                    });


                  });
                  jQuery('head').append('<link rel="stylesheet" type="text/css" href="'+window.dzsap_settings.dzsap_site_url+"wp-content/plugins/dzs-zoomsounds/audioplayer/audioplayer.css"+'"/>')

                }
              }

              if(response_arr.dzswtl_current_ids_on_page_from_all_shop_pages){
                try {
                  window.dzswtl_current_ids_on_page_from_all_shop_pages = JSON.parse(response_arr.dzswtl_current_ids_on_page_from_all_shop_pages);
                }catch(err){
                  console.log(err);
                }
              }


              try{
                var queries = JSON.parse(response_arr.margs);

                // console.info(queries);


                newurl = dzs_helpers.remove_query_arg_all(window.location.href);


                newurl = dzs_helpers.add_query_args(newurl, queries);

                // console.info(url);

                // -- eliminate args we don't need from $_GET

                newurl = dzs_helpers.add_query_arg(newurl,'add-to-cart','NaN');
                newurl = dzs_helpers.add_query_arg(newurl,'pagination_include_dots','NaN');
                newurl = dzs_helpers.add_query_arg(newurl,'pagination_range','NaN');
                newurl = dzs_helpers.add_query_arg(newurl,'pagination_prev_next','NaN');
                newurl = dzs_helpers.add_query_arg(newurl,'page_url','NaN');
                newurl = dzs_helpers.add_query_arg(newurl,'return_only_items','NaN');
                newurl = dzs_helpers.add_query_arg(newurl,'get_preview_data','NaN');
                newurl = dzs_helpers.add_query_arg(newurl,'layout_mode','NaN');
                newurl = dzs_helpers.add_query_arg(newurl,'post_type_2','NaN');
                newurl = dzs_helpers.add_query_arg(newurl,'call_from','NaN');
                newurl = dzs_helpers.add_query_arg(newurl,'show_filtered_by','NaN');
                newurl = dzs_helpers.add_query_arg(newurl,'paged','NaN');
                newurl = dzs_helpers.add_query_arg(newurl,'add_to_cart_style','NaN');
                newurl = dzs_helpers.add_query_arg(newurl,'product_attributes','NaN');
                newurl = dzs_helpers.add_query_arg(newurl,'hard_meta_query','NaN');
                newurl = dzs_helpers.add_query_arg(newurl,'randomize','NaN');
                newurl = dzs_helpers.add_query_arg(newurl,'ids','NaN');
                newurl = dzs_helpers.add_query_arg(newurl,'extra_classes','NaN');
                newurl = dzs_helpers.add_query_arg(newurl,'recalculate_attribute_data','NaN');
                newurl = dzs_helpers.add_query_arg(newurl,'button_style','NaN');
                newurl = dzs_helpers.add_query_arg(newurl,'pagination_skin','NaN');
                newurl = dzs_helpers.add_query_arg(newurl,'per_row','NaN');
                newurl = dzs_helpers.add_query_arg(newurl,'called_from_post_id','NaN');
                newurl = dzs_helpers.add_query_arg(newurl,'cookie_set_posts_per_page','NaN');
                newurl = dzs_helpers.add_query_arg(newurl,'cookie_set_layout','NaN');
                newurl = dzs_helpers.add_query_arg(newurl,'default_order','NaN');
                newurl = dzs_helpers.add_query_arg(newurl,'default_orderby','NaN');

                // console.log('%c hard_coded_keys here -5 ','background-color: #dadada',hard_coded_keys);
                for(var lab in hard_coded_keys){
                  newurl = dzs_helpers.add_query_arg(newurl,lab,'NaN');
                }


                if(arg_posts_per_page_changed==false){

                  newurl = dzs_helpers.add_query_arg(newurl,'posts_per_page','NaN');
                }

                if(arg_layout_changed==false){

                  newurl = dzs_helpers.add_query_arg(newurl,'layout','NaN');
                }




                if(pagination_method=='scroll'){
                  newurl = dzs_helpers.add_query_arg(newurl,'paged','NaN');
                }

                if(newurl.indexOf('?')==-1 && newurl.indexOf('&')>-1){
                  newurl = newurl.replace('&','?');
                }
                // console.log('%c newurl -2 ','background-color: #dadaff',newurl);

              }catch(err){

                console.error('cannot parse - ',response_arr.margs, err);
              }




              // console.warn(response_arr);



              var _ajaxContainer = $('.dzswtl-ajax-container').eq(0);

              if(cthis.hasClass('woo-table-is-zfolio')){

              }

              // console.log('_ajaxContainer - ',_ajaxContainer);


              if(margs.call_from=='scroll' && pagination_method=='scroll'){

                _ajaxContainer.append(response_arr.output);
              }else{

                _ajaxContainer.html(response_arr.output);
              }





              pages_curr = Number(response_arr.paged);
              pages_max = Number(response_arr.max_num_pages);
              // pages_max = Number(response_arr.max_num_pages);



              // console.warn('response_arr.max_num_pages - ', response_arr.max_num_pages);

              if(Number(response_arr.max_num_pages)!=_pagination.find('.pagination-number').length || 1){

                // -- if different length

                var aux = '';
                for(var i = 1; i<=Number(response_arr.max_num_pages);i++){
                  aux+='<a href="'+dzs_helpers.add_query_arg(window.location.href,'table_paged',i)+'" class="pagination-number dzs-woo-ajax pagination-link "><span class="the-pagination-number--inner">'+i+'</span></a>';
                }


                if(_pagination.find('.prev-pagination-btn').length){
                  aux = _pagination.find('.prev-pagination-btn').get(0).outerHTML + aux;
                }
                if(_pagination.find('.next-pagination-btn').length){
                  aux = aux + _pagination.find('.next-pagination-btn').get(0).outerHTML ;
                }


                aux+='<div class="clearfix"></div>';

                // -- replace with new pagination here


                _pagination.html(aux);
              }




              if(isNaN(Number(pages_max))==false){
                _targetShop.attr('data-max_num_pages', pages_max);
                _targetShop.find('.dzs-pagination').attr('data-max_num_pages', pages_max);
              }else{
                pages_max = Number(cthis.attr('data-max_num_pages'));
              }
              if(isNaN(Number(pages_curr))==false){
                _targetShop.attr('data-curr_paged', pages_curr);
              }



              _pagination.find('.pagination-number').removeClass('current');
              _pagination.find('.pagination-number').eq(pages_curr-1).addClass('current');


              var ind = 1;
              _pagination.find('.pagination-number').each(function(){


                var _t = $(this);

                var good_href = newurl;

                good_href = good_href.replace('#','');

                if(good_href==''){
                  good_href = newurl;
                }

                good_href = dzs_helpers.add_query_arg(good_href, 'table_paged',ind);

                _t.attr('href', good_href);

                ind++;








              });





              if(response_arr.filtered_by){


                var filt_by = response_arr.filtered_by;

                var count = 0;
                var i;

                for (i in filt_by) {
                  if (filt_by.hasOwnProperty(i) && filt_by[i].value) {
                    count++;
                  }
                }
                // console.info('filtered_by -> ',response_arr.filtered_by,count);


                if(count){

                  var arr = response_arr.filtered_by;



                  for(var lab in arr){
                    var ca = arr[lab];

                    console.warn('filtering by - ', ca);

                    // -- we get this from ajax but sometimes they have no value.. so lets filter
                    // -- todo: we will never have value "" , we use "none" ;)
                    if(ca.value==''){
                      continue;
                    }


                    var aux = '';

                    $('.filtered-by-filter[data-lab_full='+ca['lab_full']+']').remove();

                    aux+='<span class="filtered-by-filter" data-lab_full="'+ca['lab_full']+'"><span class="the-label">'+ca['label']+'</span>';

                    aux+='<span class="the-close delete-filter"  data-lab_full="'+ca['lab_full']+'">'+'<i class="fa fa-window-close"></i>'+'</span>';
                    aux+='</span>';




                    $('.filtered-by-con').append(aux)
                  }





                  $('.filtered-by-con').removeClass('no-filters');



                  $('.filtered-by-filter').each(function(){


                    var _t3 = $(this);

                    var sw = false;


                    var lab = _t3.attr('data-lab_full');

                    for(var i3 in arr) {
                      var ca = arr[i3];

                      if(ca['lab_full']==lab){
                        sw=true;
                      }
                    }



                    if(sw==false){
                      _t3.remove();
                    }



                  })


                }else{
                  $('.filtered-by-con').addClass('no-filters');



                  $('.filtered-by-filter').remove();
                }
              }



              if(dzs_helpers.get_query_arg(newurl,'subcat_slug')){

                newurl = dzs_helpers.add_query_arg(newurl,'subcat',dzs_helpers.get_query_arg(newurl,'subcat_slug'));
                newurl = dzs_helpers.add_query_arg(newurl,'subcat_slug','NaN');
              }

              newurl = dzs_helpers.add_query_arg(newurl,'dzswtl_action','NaN');


              // if (history_first_pushed_state == false) {
              //
              //     if (window.location.href.indexOf('file://') === -1) {
              //
              //         var aux = curr_html;
              //         if (aux == 'index.php') {
              //             aux = '';
              //         }
              //
              //         var stateObj = {href: curr_html};
              //
              //         history.pushState(stateObj, null, aux);
              //     }
              //     history_first_pushed_state = true;
              // }

              // var aux_arr = state_curr_menu_items_links.slice(0);

              //, 'curr_menu_items': aux_arr

              // page_change_ind++;
              //console.info('PUSH STATE', stateObj, thehref)




              // && newurl!=window.location.href
              if(newurl  && newurl!=window.location.href){

                var stateObj = {foo: 0, href: newurl};
                history.pushState(stateObj, null, newurl);
              }




              setTimeout(function(){
                reinit_pagination()
                get_current_ids_on_page();
              },100);


            }catch(err){
              console.error('cannot parse - ',response);
              console.error(err);
            }
            cthis.removeClass('loading');
            busy=false;
            reinit_stars();
          }

          ,error: function(err){
            console.error('error loading',err);
            cthis.removeClass('loading');
            busy=false;
            reinit_stars();
          }
        });




      }

























    })

  }
})(jQuery);



window.dzswtl_init = function($){


  jQuery('.dzs-woo-table').dzswootable();

  jQuery(document).on('change','.dzs-woo-feed[data-dzs-woo-term-parent="0"] ~ select',dzswtl_filter_from_reinit);


  jQuery('.dzswtl-for-wishlist-entry').each(function(){
    var _t = jQuery(this);

    // console.info('_t - ',_t);

    if(window.dzswtl_settings && dzswtl_settings.wishlist_ids){

      // console.info('_t.attr(\'data-post_id\') - ',_t.attr('data-post_id'));
      if(_t.attr('data-post_id')){


        // console.info(dzswtl_settings.wishlist_ids, dzswtl_settings.wishlist_ids.indexOf(_t.attr('data-post_id')))

        if(dzswtl_settings.wishlist_ids.indexOf && dzswtl_settings.wishlist_ids.indexOf(_t.attr('data-post_id'))>-1){

          if(_t.find('.svg-icon').hasClass('fa-star-o')){
            _t.find('.svg-icon').eq(0).attr('class','svg-icon fa fa-star');

            _t.addClass('wishlist-activated');
          }else{

            _t.find('.svg-icon').eq(0).attr('class','svg-icon fa fa-star-o');
            _t.removeClass('wishlist-activated');
          }
        }
      }
    }
  })

  reinit();

  function reinit(){



    dzswtl_filter_from_reinit();
    if(jQuery('.dzs-wtl-submit-changes-btn').length){

      window.dzswtl_block_changes = true;
      window.dzswtl_collect_args_in_timeout = true;
    }

    setTimeout(function(){

      dzswtl_filter_from_reinit();
    },500);
  }






  jQuery(document).on( 'click',' .dzswtl-wishlist-but', function() {
    var _t = jQuery(this);



    if (_t.hasClass('dzswtl-wishlist-but')) {




      var data = {
        action: 'dzswtl_add_to_wishlist',
        playerid: _t.attr('data-post_id'),
        wishlist_action: 'add',
      };


      if(_t.hasClass('wishlist-activated') || _t.find('.svg-icon').hasClass('fa-star')){
        data.wishlist_action = 'remove';
      }



      if (window.dzswtl_settings.ajaxurl) {
        jQuery.ajax({
          type: "POST",
          url: window.dzswtl_settings.ajaxurl,
          data: data,
          success: function(response) {
            //if(typeof window.console != "undefined" ){ console.log('Ajax - get - comments - ' + response); }



            if(_t.find('.svg-icon').hasClass('fa-star-o')){
              _t.find('.svg-icon').eq(0).attr('class','svg-icon fa fa-star');
              _t.addClass('wishlist-activated');
            }else{

              _t.find('.svg-icon').eq(0).attr('class','svg-icon fa fa-star-o');
              _t.removeClass('wishlist-activated');
            }

          },
          error: function(arg) {
            if (typeof window.console != "undefined") {
              // console.log('Got this from the server: ' + arg, arg);
            };
          }
        });
      }

      return false;


    }

  })


};


jQuery(document).ready(function($){

  window.dzswtl_init($);

})



function dzswtl_filter_from_reinit(){

  var $ = jQuery;

  $('.dzs-woo-feed-filter-from').each(function(){
    var _t2 = $(this);

    // console.info('_t2 - ',_t2);

    if(_t2.attr('data-dzs-woo-term-parent')=='auto'){
      // console.warn(_t2);

      var _woofilter = _t2.parent();




      var _feed = $('.dzs-woo-feed[data-dzs-woo-term-parent="0"]').eq(0).parent().find('.dzs-woo-table-filter-input:not(.dzs-select-wrapper)').eq(0);

      var feedval = _feed.val();


      if(feedval) {


        if(feedval!=_feed.data('last_feedval')){


          $.ajax({
            async: "false"
            , method: "POST"
            // ,contentType: "application/x-www-form-urlencoded; charset=UTF-8"
            // ,type: "POST"
            , url: window.dzswtl_settings.admin_url + '?dzswtl_action=load_subcats'
            , data: {
              hmm: 'ceva'
              , postdata: feedval
            }
            , dataType: 'html'
            , success: function (response) {
              // console.info(response);


              var dataarr = [];
              try{
                dataarr = JSON.parse(response);


                // console.log('dataarr - ', dataarr);

                var newselecthtml = '';

                newselecthtml+='<option value="">'+_woofilter.find('.label-all').text()+'</option>';
                for(var i =0;i<dataarr.length;i++){

                  newselecthtml+='<option ';


                  if(dzs_helpers.get_query_arg(window.location.href,'subcat')==dataarr[i].slug){
                    newselecthtml+=' selected';
                  }


                  newselecthtml+= ' value="'+dataarr[i].slug+'">'+dataarr[i].name+'</option>';
                }
                _woofilter.find('.dzs-select-wrapper select').html(newselecthtml);


                // _woofilter.find('.dzs-select-wrapper select').get(0).api_recheck_value_from_input();

                setTimeout(function(_woofilter){

                  _woofilter.find('.dzs-select-wrapper select').get(0).api_recheck_value_from_input();
                  // _woofilter.find('.dzs-select-wrapper select').get(0).api_reinit();


                },500,_woofilter);
              }catch(err){
                console.warn(err);
              }
            }
          })

          console.warn('_feed - ', _feed);
          console.warn('feedval - ', feedval);

          _feed.data('last_feedval', feedval);
        }



      }else{
        _woofilter.find('.dzs-select-wrapper-head .the-text').html(_woofilter.find('.label-auto-empty').html());
      }
    }
  });
}


window.trigger_change_on_target_inter = 0;
window.trigger_change_on_target = function(arg){
  console.info('TRIGGERED CHANGE"');
  arg.trigger('change');
}










window.dzs_open_social_link = dzs_helpers.dzs_open_social_link;






